import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Ticket = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      stroke={stroke}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/ticket">
        <g id="ticket">
          <path
            id="Vector"
            d="M1.33203 9.66663C1.44093 9.66663 1.54749 9.65602 1.65073 9.6358L1.33203 9.71157V9.66663ZM1.99975 12.6656C1.95451 12.6203 1.91151 12.5715 1.87075 12.5188C1.91878 12.5793 1.97115 12.6369 2.02825 12.6914C2.067 12.7285 2.10711 12.7633 2.14853 12.7961C2.09502 12.7549 2.04556 12.7114 1.99975 12.6656ZM14.6654 9.99996C14.6654 10.0155 14.6653 10.031 14.6653 10.0465L14.2744 9.95352C13.5558 9.78268 13.0186 9.14173 12.9992 8.37611C13.0222 9.27271 13.7635 9.99996 14.6654 9.99996ZM13.8767 12.7718C13.9937 12.6749 14.0935 12.5666 14.1786 12.4476C14.1229 12.5283 14.0626 12.6006 13.9976 12.6656C13.9324 12.7308 13.8598 12.7914 13.7786 12.8473C13.812 12.8234 13.8448 12.7982 13.8767 12.7718ZM14.6654 6.66663C14.5565 6.66663 14.4499 6.67723 14.3467 6.69745L14.6654 6.62168V6.66663ZM1.33203 6.33329V6.28835L1.65073 6.36412C1.54749 6.3439 1.44093 6.33329 1.33203 6.33329ZM2.02825 3.30848C1.97115 3.36305 1.91879 3.42066 1.87076 3.48112C1.91151 3.42838 1.95452 3.37958 1.99975 3.33435C2.04555 3.28854 2.09501 3.24503 2.14851 3.20382C2.1071 3.23662 2.06699 3.27146 2.02825 3.30848ZM13.9976 3.3376C13.9351 3.27494 13.8688 3.21822 13.7989 3.16686C13.872 3.21877 13.9379 3.27461 13.9976 3.33435C14.0552 3.39193 14.1092 3.45528 14.1595 3.52519C14.1105 3.45945 14.0567 3.39684 13.9976 3.3376Z"
          />
          <path
            id="Vector_2"
            d="M6.66797 4.83329C6.39464 4.83329 6.16797 4.60663 6.16797 4.33329V2.66663C6.16797 2.39329 6.39464 2.16663 6.66797 2.16663C6.9413 2.16663 7.16797 2.39329 7.16797 2.66663V4.33329C7.16797 4.60663 6.9413 4.83329 6.66797 4.83329Z"
          />
          <g id="Vector_3">
            <mask id="path-3-inside-1_3025_1060">
              <path d="M6.66797 9.71998C6.39464 9.71998 6.16797 9.49332 6.16797 9.21998V6.77332C6.16797 6.49998 6.39464 6.27332 6.66797 6.27332C6.9413 6.27332 7.16797 6.49998 7.16797 6.77332V9.21998C7.16797 9.49998 6.9413 9.71998 6.66797 9.71998Z" />
            </mask>
            <path d="M6.66797 9.71998C6.39464 9.71998 6.16797 9.49332 6.16797 9.21998V6.77332C6.16797 6.49998 6.39464 6.27332 6.66797 6.27332C6.9413 6.27332 7.16797 6.49998 7.16797 6.77332V9.21998C7.16797 9.49998 6.9413 9.71998 6.66797 9.71998Z" />
            <path
              d="M6.66797 8.71998C6.94692 8.71998 7.16797 8.94103 7.16797 9.21998H5.16797C5.16797 10.0456 5.84235 10.72 6.66797 10.72V8.71998ZM7.16797 9.21998V6.77332H5.16797V9.21998H7.16797ZM7.16797 6.77332C7.16797 7.05227 6.94692 7.27332 6.66797 7.27332V5.27332C5.84235 5.27332 5.16797 5.9477 5.16797 6.77332H7.16797ZM6.66797 7.27332C6.38902 7.27332 6.16797 7.05227 6.16797 6.77332H8.16797C8.16797 5.9477 7.49359 5.27332 6.66797 5.27332V7.27332ZM6.16797 6.77332V9.21998H8.16797V6.77332H6.16797ZM6.16797 9.21998C6.16797 8.93903 6.39773 8.71998 6.66797 8.71998V10.72C7.48488 10.72 8.16797 10.0609 8.16797 9.21998H6.16797Z"
              mask="url(#path-3-inside-1_3025_1060)"
            />
          </g>
          <path
            id="Vector_4"
            d="M6.66797 13.8333C6.39464 13.8333 6.16797 13.6066 6.16797 13.3333V11.6666C6.16797 11.3933 6.39464 11.1666 6.66797 11.1666C6.9413 11.1666 7.16797 11.3933 7.16797 11.6666V13.3333C7.16797 13.6066 6.9413 13.8333 6.66797 13.8333Z"
          />
        </g>
      </g>
    </svg>
  );
};

Ticket.displayName = 'Ticket';
